import { calcConnTime } from "./timeUtils";

export const MCT_THRESHOLDS = {
  TBIT_inbound:  { unachievable: 60, achievable: 120 },
  AC_to_partner: { unachievable: 60, achievable: 90  },
  AC_to_UA:      { unachievable: 30, achievable: 60  },
  UA_to_partner: { unachievable: 60, achievable: 90  },
  UA_to_AC:      { unachievable: 30, achievable: 60  },
};

function getMctKey(inAirline, outAirline) {
  const inUA  = inAirline  === "UA";
  const inAC  = inAirline  === "AC";
  const outUA = outAirline === "UA";
  const outAC = outAirline === "AC";

  if (!inUA && !inAC) return "TBIT_inbound";
  if (inAC && !outUA) return "AC_to_partner";
  if (inAC && outUA)  return "AC_to_UA";
  if (inUA && outAC)  return "UA_to_AC";
  if (inUA && !outAC) return "UA_to_partner";
  return null;
}

// Returns 'AT_RISK' | 'TIGHT' | 'SAFE' | null
export function getMctRisk(entry) {
  if (!entry || entry.cancelled || entry.atd === "XCL") return null;
  if (entry.status === "COMPLETED" || entry.status === "OFFLOADED") return null;
  const inA  = (entry.inAirline  || "").toUpperCase();
  const outA = (entry.outAirline || "").toUpperCase();
  if (!inA || !outA) return null;
  const key = getMctKey(inA, outA);
  if (!key) return null;
  const mins = calcConnTime(entry);
  if (mins === null) return null;
  const { unachievable, achievable } = MCT_THRESHOLDS[key];
  if (mins < unachievable) return "AT_RISK";
  if (mins < achievable)   return "TIGHT";
  return "SAFE";
}
